import { SITE } from './src/app/constants/site';

// 根据 tag 判断环境
export const getEnvironment = () => {
  const tag = process.env.NEXT_PUBLIC_APP_TAG || '';
  // aivid 是 cn / cntest / dev 之上的企业版变体后缀，独立成一个环境维度
  const variantSuffix = tag.includes('aivid') ? '-aivid' : '';

  // 优先使用 tag 判断环境
  if (tag && !tag.includes('dev')) {
    if (tag.includes('sgtest')) return `sg-test${variantSuffix}`;
    if (tag.includes('cntest')) return `cn-test${variantSuffix}`;
    if (tag.includes('sg')) return `sg-prod${variantSuffix}`;
    if (tag.includes('cn')) return `cn-prod${variantSuffix}`;
  }

  // 如果没有 tag，使用站点信息作为环境标识
  return `${SITE}-dev${variantSuffix}`;
};

// 根据环境设置采样率
export const getSampleRates = (env: string) => {
  // 只在生产环境上报数据
  if (env.includes('prod')) {
    return {
      tracesSampleRate: 1, // 性能追踪采样 100%
      replaysOnErrorSampleRate: 1, // 错误重放采样 100%
      replaysSessionSampleRate: 1, // 会话重放采样 100%
    };
  }

  // 非生产环境不上报数据
  return {
    tracesSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    replaysSessionSampleRate: 0,
  };
};

// Sentry 过滤配置
export const getSentryFilters = () => ({
  // 忽略的 URL 模式 - 过滤第三方扩展和用户脚本
  denyUrls: [
    // 浏览器扩展相关
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^safari-extension:\/\//i,
    /^moz-extension:\/\//i,
    /extension:\/\//i,
    /extensions\//i,

    // 密码管理器
    /lastpass/i,
    /1password/i,

    // 广告拦截器
    /adblock/i,
    /ublock/i,

    // 应用内页面
    /app:\/\/\/userscript\.html/i,
    /app:\/\/\/scripts\/inpage\.js/i,
    /frame_ant/i,
  ],

  // 忽略的错误类型 - 过滤常见的非关键错误
  ignoreErrors: [
    // 跨域脚本错误,由于浏览器安全策略限制无法获取详细信息
    'Script error',
    // ResizeObserver 相关错误,通常是由于 DOM 元素大小变化过快导致,不影响功能
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    // 请求被用户或程序主动中断,属于正常行为
    'Request aborted',
    // AbortError 系列:用户主动取消请求 / 页面跳转中断,纯噪音
    'AbortError',
    'signal is aborted without reason',
    'The operation was aborted',
    'The user aborted a request',
    // 用户拒绝授权剪贴板 / 媒体 / 通知 等,正常用户行为
    'NotAllowedError',
    /request is not allowed by the user agent/i,
    // App 内嵌 WebView 生命周期问题,前端不可修
    /Java object is gone/i,
    // 浏览器翻译插件(沉浸式翻译 / Chrome 自带翻译等) 改 DOM 后 React 协调失败,业内公认噪音
    /Failed to execute 'removeChild' on 'Node'/,
    /Failed to execute 'insertBefore' on 'Node'/,
    // 网络连接错误,通常由用户网络状况导致,应用层无法处理
    'Network Error',
    // Promise rejection 没有使用 Error 对象,缺少堆栈信息,不具备排查价值
    'Non-Error promise rejection captured',
    // 现有的业务错误过滤
    /BusinessError:/,
    // 过滤 chunk 加载失败错误:
    // 1. 这类错误通常发生在用户停留在老 tab 时跨过一次发版,client navigation 去加载新版本资源
    // 2. GlobalClientInit 已接入一次性 reload 兜底,这类错误大多能在刷新后恢复
    // 3. 如果刷新后仍失败,用户会进入全局错误兜底,届时再保留真正不可恢复的异常信号即可
    /ChunkLoadError/,
    /Loading chunk [^\\s]+ failed/i,
    /Loading CSS chunk [^\\s]+ failed/i,
    /module factory is not available/i,

    /window\.webkit\.messageHandlers/,
    /webkit\.messageHandlers/,
  ],
  // 仅允许 Sentry 捕获以下网站主域名的错误
  whitelistUrls: [/https:\/\/(www|abc)\.vidu\.cn/, /https:\/\/(www|abc)\.vidu\.com/],
});
